<template>
  <v-container>
    <v-layout
      text-xs-center
      wrap
    >
      <!-- Dialog to display/update relationship info -->
      <v-dialog
        v-model="dialog"
        scrollable  
        persistent
        max-width="850px"
        transition="dialog-transition"
      >
        <v-card>
          <v-card-title>
            <span class="headline">
              Relationship between {{viewedMentor.name}} (Mentor) and {{viewedClient.name}} (Client)
            </span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <!-- Visible for clients when relationship is 'requested' -->
              <v-layout row wrap v-if="wholeItem.relationshipStatus == 'requested'">
                <v-flex xs12>
                  <span class="title">
                    The relationship request is still being considered by the mentor
                  </span>
                </v-flex>
              </v-layout>
              <!-- Always visible -->
              <v-layout wrap v-if="!((wholeItem.relationshipStatus == 'requested' || wholeItem.relationshipStatus == 'rejected') && wholeItem.client.email == myProfile.email)">
                <v-flex xs12>
                  <span class="title">
                    Contact Details
                  </span>
                </v-flex>
                <v-flex xs6>
                  <v-text-field 
                    v-model="viewedMentor.email"
                    readonly
                    hide-details
                    label="Mentor Email"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field 
                    v-model="viewedClient.email"
                    readonly
                    hide-details
                    label="Client Email"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field 
                    v-model="viewedMentor.location" 
                    readonly
                    hide-details
                    label="Mentor Location"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field 
                    v-model="viewedClient.location" 
                    readonly
                    hide-details
                    label="Client Location"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field 
                    v-model="viewedMentor.telephone" 
                    readonly
                    label="Mentor Telephone"></v-text-field>
                </v-flex>
                <v-flex xs6>
                  <v-text-field 
                    v-model="viewedClient.telephone" 
                    readonly
                    label="Client Telephone"></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-text-field 
                    v-model="wholeItem.requestDateTime" 
                    readonly
                    label="Relationship requested on"></v-text-field>
                </v-flex>
              </v-layout>
              <!-- Only visible for rejected relationships -->
              <v-layout row wrap v-if="wholeItem.relationshipStatus == 'rejected'">
                <v-flex xs12>
                  <span class="subheading">
                    The relationship request was turned down for the following reason
                  </span>
                </v-flex>
                <v-flex xs10 offset-xs1>
                  {{wholeItem.rejectionReason}}
                </v-flex>
              </v-layout>
              <!-- Only visible for active and complete relationships -->
              <v-layout row wrap v-if="wholeItem.relationshipStatus == 'active' || wholeItem.relationshipStatus == 'complete'">
                <v-flex xs12>
                  <span class="title">
                    Relationship Details
                  </span>
                </v-flex>
                <v-flex xs3>
                  <div>
                    <v-text-field
                        slot="activator"
                        v-model="computedDateFormatted"
                        label="First meeting date"
                        prepend-icon="event"
                        readonly
                      ></v-text-field>
                  </div>
                </v-flex>
                <v-flex xs8>
                  <!-- empty flex box for spacing -->
                </v-flex>
                <v-flex xs6>
                  <v-textarea
                    v-model="wholeItem.feedback.mentor"
                    auto-grow
                    label="Mentor Feedback"
                    rows="1"
                    readonly
                  ></v-textarea>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs6>
                  <v-textarea
                    v-model="wholeItem.feedback.client"
                    auto-grow
                    label="Client Feedback"
                    rows="1"
                    readonly
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn 
              color="primary"
              text 
              @click="close">
                Close
              </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!----------------------------->
      <!-- Table of relationships  -->
      <!----------------------------->
      <v-flex xs12 sm10 md10 offset-sm1 offset-md1>
        <v-card>
          <v-toolbar dark dense color="primary">
            <v-toolbar-title class="title">
            Relationships
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-btn 
                  v-on="on"
                  slot="activator"
                  text
                  icon
                  dark
                  @click="showHelpMentor = !showHelpMentor">
                    <v-icon>help_outline</v-icon>
                </v-btn>
              </template>
              <span v-if="!showHelpMentor">Show help</span>
              <span v-else>Hide help</span>
            </v-tooltip>
          </v-toolbar>
          <v-card-title v-if="showHelpMentor">
            <template>
              <v-layout row wrap>
                <v-flex xs12>
                  <p class="text-xs-left">The status of your mentoring relationships can be viewed and updated here.  Relationships can be either pending (waiting for a response from the mentor), current or complete.</p>
                  <p class="text-xs-left">This page can also be used to provide feedback on the suitability of the relationship from the perspective of mentor and mentee.  Please do NOT use this for personal feedback, which should always be shared directory and confidently with the mentor or mentee.</p>
                </v-flex>
              </v-layout>
            </template>
          </v-card-title>

          <v-card-text>
            <template>
              <v-layout row wrap>
                <v-flex xs3 sm3 md2 pt-3>
                  <h5 class="text-sm-left headline">Filter by -</h5>  
                </v-flex>
                <v-flex xs6>
                  <v-select
                        :items="statusList"
                        v-model="filters.status"
                        label="Status"
                        @change="filterStatus"
                  ></v-select>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs2 pt-3>
                  <v-btn small 
                    color="primary"
                    ripple
                    @click="clearFilters">
                    Clear Filter
                  </v-btn>
                </v-flex>
              </v-layout>
            </template>
          </v-card-text>

          <v-data-table
            :headers="headers"
            :items="relationships"
            :search="filters.status"
            :loading="mentorsLoading"
          >
            <template slot="item" slot-scope="props">
              <tr>
              <td class="text-xs-left">{{ props.item.mentor.name }}</td>
              <td class="text-xs-left">{{ props.item.client.name }}</td>
              <td class="text-xs-left">{{ props.item.requestDateTime }}</td>
              <td class="text-xs-left">{{ formatDateView(props.item.firstMeeting) }}</td>
              <td class="text-xs-left">
                <v-tooltip right v-if="props.item.relationshipStatus == 'requested'">
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on="on"
                      slot="activator"
                      color="primary"
                    >
                      help_outline
                    </v-icon>
                  </template>
                  <span>Relationship request</span>
                </v-tooltip>
                <v-tooltip right v-else-if="props.item.relationshipStatus == 'active'">
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    slot="activator"
                    color="secondary"
                  >
                    people_outline
                  </v-icon>
                  </template>
                  <span>Active relationship</span>
                </v-tooltip>
                <v-tooltip right v-else-if="props.item.relationshipStatus == 'rejected'">
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    slot="activator"
                    color="secondary"
                  >
                    highlight_off
                  </v-icon>
                  </template>
                  <span>Relationship turned down</span>
                </v-tooltip>
                <v-tooltip right v-else>
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    slot="activator"
                    color="secondary"
                  >
                    check_circle_outline
                  </v-icon>
                  </template>
                  <span>Completed Relationship</span>
                </v-tooltip>
              </td>

              <td class="justify-center layout px-0">
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    slot="activator"
                    class="mr-2 mt-2"
                    @click="viewRelationship(props.item)"
                  >
                    visibility
                  </v-icon>
                  </template>
                  <span>View relationship details</span>  
                </v-tooltip>
              </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
      filters: {
        status: ''
      },
      menu: false,
      search: '',
      dialog: false,
      rejectionReason: false,
      rejectionText: null,
      rejectError: false,
      rejectErrorMsg: null,
      confirmationError: false,
      confirmationErrorMsg: null,
      headers: [
        { text: 'Mentor', value: 'mentor'},
        { text: 'Client', value: 'client'},
        {text: 'Request submitted', value: 'requested'},
        { text: 'First meeting', value: 'firstMeeting'},
        { text: 'Status', value: 'relationshipStatus'}
      ],
      viewedIndex: -1,
      viewedItem: {},
      viewedClient: {},
      viewedMentor: {},
      selectedItem: {},
      wholeItem: {},
      selectedMentor: {},
      defaultItem: {},
      detailTitle: null,
      conversationConfirmation: false,
      showHelpMentor: false,
      showHelpClient: false,
      statusList: [
        {text: 'Requested', value: 'requested'},
        {text: 'Active', value: 'active'},
        {text: 'Rejected', value: 'rejected'},
        {text: 'Complete', value: 'complete'}
      ],
      monthList: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
    }),
    created: function() {
      this.$store.dispatch("updateAllRelationships")
    },
    computed: {
      relationships: function() {
        return this.$store.getters.getAllRelationships
      },
      myProfile: function() {
        return this.$store.getters.getMyProfile
      },
      configData: function () {
        //return this.$store.getters.getForms
        return this.$store.getters.getConfig
      },
      mentorsLoading: function () {
        return this.$store.getters.getMentorLoading
      },
      clientsLoading: function () {
        return this.$store.getters.getClientLoading
      },
      acceptanceMsg: function () {
        return this.$store.getters.getAcceptanceMsg
      },
      computedDateFormatted () {
        return this.formatDate(this.wholeItem.firstMeeting)
      }
    },
    methods: {
      viewRelationship (item) {
        this.viewedIndex = this.relationships.indexOf(item)
        this.viewedMentor = Object.assign({}, item.mentor)
        this.viewedClient = Object.assign({}, item.client)
        this.wholeItem = Object.assign({}, item)
        this.detailTitle = "Client"
     //   console.log("REL - viewedItem", this.viewedItem)
        console.log("REL - wholeItem", this.wholeItem)
        console.log("REL - Title for", this.detailTitle)
        this.dialog = true
      },
      rejectClient (item) {
        this.wholeItem = Object.assign({}, item)
        console.log("REL - rejection Text 1 ",this.rejectionText)
        this.confirmationError = false
        this.confirmationErrorMsg = null
        this.rejectError = false
        this.rejectErrorMsg = null
        this.conversationConfirmation = false
        this.rejectionText = null
        this.rejectionReason = true
      },
      changeRelationshipStatus (item,newStatus) {
        var clientObj = Object.assign({}, item)
        clientObj.relationshipStatus = newStatus
        console.log("REL - acceptedItem", clientObj)
        this.$store.dispatch("changeRelationshipStatus",clientObj)
      },
      closeRejection () {
        console.log("REL - rejection Text 2 ",this.rejectionText)
        this.confirmationError = false
        this.confirmationErrorMsg = null
        this.rejectError = false
        this.rejectErrorMsg = null
        this.rejectionText = null
        this.rejectionReason = false
        setTimeout(() => {
          this.wholeItem = Object.assign({}, this.defaultItem)
        }, 300)
      },
      saveRejection () {
        if (this.conversationConfirmation == false) {
          this.confirmationError = true
          this.confirmationErrorMsg = "Please confirm"
        } else if (this.rejectionText == null || this.rejectionText == "") {
          this.rejectError = true
          this.rejectErrorMsg = "Please enter a Reason"
        } else {
          this.rejectError = false
          this.rejectErrorMsg = null
          this.rejectionReason = false
          console.log("REL - rejection Text 3 ",this.rejectionText)
          this.wholeItem.rejectionReason = this.rejectionText
          this.changeRelationshipStatus(this.wholeItem,"rejected")
        }
      },
      dialogSave () {
        console.log("REL - out of dialog ",this.wholeItem)
        this.$store.dispatch("changeRelationshipStatus",this.wholeItem)
        this.close()

      },
      close () {
        this.dialog = false
        setTimeout(() => {
          this.viewedItem = Object.assign({}, this.defaultItem)
          this.viewedClient = Object.assign({}, this.defaultItem)
          this.viewedMentor = Object.assign({}, this.defaultItem)
          this.wholeItem = Object.assign({}, this.defaultItem)
          this.viewedIndex = -1
        }, 300)
      },
      formatDate (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      formatDateView (date) {
        if (!date) return null

        const [year, month, day] = date.split('-')
        const monthStr = this.monthList[parseInt(month)-1]
        return `${day} ${monthStr} ${year}`
      },
      hideAcceptanceMsg () {
        this.$store.commit('setAcceptanceMsg',false)
      },
      customFilter(items, filters, filter, headers) {
        // Init the filter class.
        const cf = new this.$MultiFilters(items, filters, filter, headers);
/*
        // Use regular function(),
        // arrow functions does not allow context binding.
        // Register the global standard filter.
        cf.registerFilter('topics', function (searchWord, items) {
          if (searchWord.trim() === '') return items;
          return items.filter(item => {
            return item.topics.includes(searchWord);
          }, searchWord);
        });

        // Use regular function(),
        // arrow functions does not allow context binding.
        // Register "specialty" filter.
        cf.registerFilter('specialty', function (specialty, items) {
          // If the filter has not been applied yet
          // just return all available items.
          if (specialty.trim() === '') return items;
          // Compare each item specialty and just return the matching ones.
          return items.filter(item => {
            return item.specialty.includes(specialty);
          }, specialty);
        });
        
        // Use regular function(),
        // arrow functions does not allow context binding.
        // Register "specialty" filter.
        cf.registerFilter('role', function (role, items) {
          // If the filter has not been applied yet
          // just return all available items.
          if (role.trim() === '') return items;
          // Compare each item specialty and just return the matching ones.
          return items.filter(item => {
            return item.role == role;
          }, role);
        });
        
        // Use regular function(),
        // arrow functions does not allow context binding.
        // Register "location" filter.
        cf.registerFilter('location', function (location, items) {
          // If the filter has not been applied yet
          // just return all available items.
          if (location.trim() === '') return items;
          // Compare each item location and just return the matching ones.
          return items.filter(item => {
            return item.location.toLowerCase().includes(location.toLowerCase());
          }, location);
        });
*/
        // Use regular function(),
        // arrow functions does not allow context binding.
        // Register "status" filter.
        cf.registerFilter('status', function (status, items) {
          // If the filter has not been applied yet
          // just return all available items.
          if (status.trim() === '') return items;
          // Compare each item location and just return the matching ones.
          return items.filter(item => {
            return item.relationshipStatus.toLowerCase().includes(status.toLowerCase());
          }, status);
        });

        // Its time to run all created filters.
        // Will be executed in the order thay were defined.
        return cf.runFilters();
      },
      filterStatus(val) {
        // Handler when user input something at the "status" field.
        this.filters = this.$MultiFilters.updateFilters(this.filters, {status: val});
      },
      filterTopics(val) {
        // Handler when user input something at the "Topics" field.
        this.filters = this.$MultiFilters.updateFilters(this.filters, {topics: val});
      },
      filterSpecialty(val) {
        // Handler when user input something at the "Specialty" field.
        this.filters = this.$MultiFilters.updateFilters(this.filters, {specialty: val});
      },
      filterLocation(val) {
        //Handler when user input something at the "Location" field.
        this.filters = this.$MultiFilters.updateFilters(this.filters, {location: val});
      },
      filterRole(val) {
        //Handler when user input something at the "Role" field.
        this.filters = this.$MultiFilters.updateFilters(this.filters, {role: val});
      },
      clearFilters() {
        this.filters.status = ''
      }
    }
  }
</script>

<style>

</style>
